module.exports = __webpack_public_path__ + "static/vue/vue_mall/img/iconfont.84363ced.svg";